import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const QuoteRequestSection = () => (
  <section className="bg-primary py-16">
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
        Looking for a professional detailing?
      </h2>
      <h3 className="text-2xl md:text-3xl font-bold text-white mb-8">
        Get a FREE online quote now!
      </h3>
      <p className="text-white text-lg max-w-2xl mx-auto mb-8">
        We pride ourselves on extracting the brilliance out of your vehicle. Select your vehicle and desired services to get an instant price estimate.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
        <Button 
          size="lg" 
          asChild
          className="bg-blue-900 text-white hover:bg-blue-800 px-8 py-6 text-lg uppercase font-bold"
        >
          <Link to="/quote">Get Free Quote</Link>
        </Button>
        <Button 
          size="lg" 
          variant="outline"
          asChild
          className="border-white text-white hover:bg-white hover:text-primary px-8 py-6 text-lg uppercase font-bold"
        >
          <Link to="/booking">Book Now</Link>
        </Button>
        <a 
          href="tel:+16512869930" 
          className="text-white text-xl font-semibold hover:underline"
        >
          (651) 286-9930
        </a>
      </div>
      <p className="text-white mt-4">
        Monday-Sunday 8am-7pm
      </p>
    </div>
  </section>
);

export default QuoteRequestSection; 